import {
  PAGE_ID_CREATE,
  PAGE_ID_EDIT,
  PAGE_ID_MULTI_LOCATION,
  PAGE_ID_REFRESH,
} from 'src/app/constants/pageUid';
import type { RouteName } from 'src/app/routes';
import CreateFlowContainer from 'src/app/views/containers/CreateFlowContainer';
import EditFlowContainer from 'src/app/views/containers/EditFlowContainer';
import MultiLocationContainer from 'src/app/views/containers/MultiLocationContainer';
import RefreshFlowContainer from 'src/app/views/containers/RefreshFlowContainer';
import type { ContainerProps } from 'src/types/app';

// Specify the Container component for each top level route
export const routeNameToContainer: Record<
  RouteName,
  (props: ContainerProps) => JSX.Element | null
> = {
  [PAGE_ID_CREATE]: CreateFlowContainer,
  [PAGE_ID_MULTI_LOCATION]: MultiLocationContainer,
  [PAGE_ID_EDIT]: EditFlowContainer,
  [PAGE_ID_REFRESH]: RefreshFlowContainer,
};
